var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "#1790FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4025,
    cy: 14.7453,
    r: 14.652,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35481 9.15948C9.688 11.1354 13.782 14.6117 14.9853 15.6956C15.1468 15.8419 15.3201 15.9163 15.4999 15.9163C15.6794 15.9163 15.8524 15.8426 16.0136 15.697C17.2179 14.6121 21.3119 11.1354 23.6451 9.15948C23.7904 9.03669 23.8125 8.82087 23.6949 8.67076C23.423 8.32389 23.0177 8.125 22.5833 8.125H8.41661C7.98222 8.125 7.57684 8.32389 7.30501 8.67079C7.1874 8.82087 7.20955 9.03669 7.35481 9.15948Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7946 10.2303C23.669 10.1718 23.5213 10.1922 23.4169 10.2815C20.8294 12.4749 17.5271 15.2865 16.4881 16.2228C15.905 16.7492 15.0957 16.7492 14.5111 16.2221C13.4037 15.2242 9.6953 12.0717 7.58311 10.2815C7.47796 10.1922 7.32994 10.1725 7.20543 10.2303C7.08025 10.2884 7 10.4136 7 10.5516V19.4583C7 20.2397 7.63534 20.875 8.41668 20.875H22.5834C23.3647 20.875 24 20.2397 24 19.4583V10.5516C24 10.4136 23.9197 10.2881 23.7946 10.2303Z",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/iconEmail.0700f4bd.svg";
export { ForwardRef as ReactComponent };